import type { QueryClient } from '@tanstack/react-query';

export type InfluencePendingFlags = {
  influencePending?: boolean;
  recalculationPending?: boolean;
};

/** Réponse API avec recalcul d’influence encore en cours côté serveur. */
export function isInfluencePending(res: unknown): boolean {
  if (!res || typeof res !== 'object') return false;
  const r = res as InfluencePendingFlags;
  return !!(r.influencePending || r.recalculationPending);
}

type ScheduleOpts = {
  /** Clés React Query à invalider (défaut : carte + territoires + empire). */
  queryKeys?: ReadonlyArray<ReadonlyArray<string>>;
  bumpMapPaint?: () => void;
  /** Délais (ms) pour rattraper le job PHP après flush. */
  delaysMs?: ReadonlyArray<number>;
};

const DEFAULT_KEYS: ReadonlyArray<ReadonlyArray<string>> = [
  ['geojson'],
  ['territory'],
  ['empire-mine'],
];

/**
 * Invalide les caches liés à l’influence.
 * Si `pending`, ne bloque pas l’UI : 1er refresh après le recalc typique, 2ᵉ pour les gros graphes.
 */
export function scheduleInfluenceRefresh(
  qc: QueryClient,
  pending: boolean,
  opts: ScheduleOpts = {},
): void {
  const keys = opts.queryKeys ?? DEFAULT_KEYS;
  // 1er tick tôt (leadership provisoire déjà en base) ; suivants pour gros graphes.
  const delays = opts.delaysMs ?? [200, 800, 2200, 4500];
  const refresh = () =>
    Promise.all(keys.map((queryKey) => qc.invalidateQueries({ queryKey }))).then(() => {
      opts.bumpMapPaint?.();
    });

  if (!pending) {
    void refresh();
    return;
  }
  // Refresh immédiat + retries : la couleur ne doit plus dépendre d’un F5.
  void refresh();
  for (const ms of delays) {
    window.setTimeout(() => {
      void refresh();
    }, ms);
  }
}
